export default "__VITE_ASSET__D0oX8inN__"